import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomerReviewComponent } from './customer-review.component';
import { FormsModule } from '@angular/forms';
import { SharedModule } from 'projects/sepidz-web-framework-shell/src/lib/shared/shared.module';
import { SepidzGridModule } from 'projects/sepidz-web-framework-data-grid/src/lib/grid.module';
import { ReportReviewModule } from 'src/app/review/review.module';


const components =
  [
    CustomerReviewComponent
  ]
@NgModule({
    declarations: [...components],
    exports: [...components],
    imports: [
        CommonModule,
        FormsModule,
        SharedModule.forRoot(),
        SepidzGridModule,
        ReportReviewModule
    ]
})
export class CustomerReviewModule { }
